import { FC } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'

import useDispatch from 'hooks/useDispatch'
import { changePassword } from 'actions/authActions'
import { HeadingLg, ParagraphXs } from 'components/display/Typography'
import { Submit } from 'components/form'

import AuthTextField from '../AuthTextField'
import { AuthToken } from '../shared'
import { FieldWrapper } from '../styles'

interface ResetPasswordFormFormValues {
  user: { email: string }
}

interface ResetPasswordFormProps {
  onSuccess: () => any
}

const validationSchema = Yup.object({
  user: Yup.object({
    email: Yup.string()
      .required('This field is required')
      .email('Not a valid email'),
  }),
})

const ResetPasswordForm: FC<ResetPasswordFormProps> = ({ onSuccess }) => {
  const dispatch = useDispatch()
  const form = useForm<ResetPasswordFormFormValues>({
    mode: 'onSubmit',
    resolver: yupResolver(validationSchema),
    defaultValues: { user: { email: '' } },
  })

  const onSubmit = (formValues: ResetPasswordFormFormValues) =>
    // @ts-ignore -- changePassword not typed
    dispatch(changePassword(formValues)).then(onSuccess)

  return (
    <FormProvider {...form}>
      <form className="qa-login" onSubmit={form.handleSubmit(onSubmit)}>
        <FieldWrapper>
          <HeadingLg noMargin>Forgot your password?</HeadingLg>
          <ParagraphXs noMargin notResponsive>
            Enter the email address you used when you joined and we&apos;ll send
            you instructions to reset your password.
          </ParagraphXs>
        </FieldWrapper>

        <AuthToken />

        <FieldWrapper margin="medium">
          <AuthTextField
            label="Email"
            name="user[email]"
            type="email"
            noMargin
          />
        </FieldWrapper>

        <FieldWrapper>
          <Submit name="commit" fullwidth uppercase={false}>
            Send reset link
          </Submit>
        </FieldWrapper>
      </form>
    </FormProvider>
  )
}

export default ResetPasswordForm
